<mat-menu #btnSelectStatus="matMenu" >
  <div style="padding: 0px 8px;" >
    <button id="buttonmat" *ngFor="let option of options"  [ngStyle]="{'width.px': specialWidth && isMobile ? specialWidth : (widthPx ? widthPx : 190)}"
    [ngClass]="{'gts-btn-select-option-primary-select': selected === option.value, 'gts-btn-select-option-primary': selected !== option.value}"
            matRipple style="width: 100%" (click)="onChange(option.value)">
      <span class="gts-btn-text">{{ option.label }}</span>
      <span class="gts-btn-icon-right" *ngIf="selected === option.value">done</span>
    </button>
  </div>
</mat-menu>
<button *ngIf="!outline" class="gts-btn-select-primary" matRipple [matMenuTriggerFor]="btnSelectStatus" [disabled]="disabled" [type]="type" style="max-width: 310px ">
  <span class="gts-btn-text">{{label}}: <b>{{ getSelectedLabel() }}</b></span>
  <span class="gts-btn-select-icon">expand_more</span>
</button>
  





<mat-menu #btnSelectStatusWithIcon="matMenu" style="max-width: auto !important;">
    <div style="padding: 0px 8px">
      <button *ngFor="let option of optionsIcons"
              [ngClass]="selected === option.value ? 'gts-btn-select-option-primary-select-outline' : 'gts-btn-select-option-primary-outline'"
              matRipple style="width: 100%; height: 100% !important; align-items:normal; text-align: left; margin-bottom: 8px;" (click)="onChange(option.value)">
        <span class="material-icons" style="padding-right: 8px; font-size: 18px;" [style.color]="option.iconColor" *ngIf="option.icon">{{option.icon}}</span>
        <span style="font-family: 'Roboto'; font-size: 14px; font-weight: 500 !important; text-transform: capitalize !important;">{{ option.label }}</span>
        <span class="gts-btn-icon-right" *ngIf="selected === option.value">done</span>
      </button>
    </div>
</mat-menu>
  

  <button *ngIf="outline" class="gts-btn-select-primary-outline" matRipple [matMenuTriggerFor]="btnSelectStatusWithIcon" [disabled]="disabled">
    <div style="display: flex; align-items: center;">
      <span class="material-icons" style="padding-right: 8px; font-size: 18px;" [style.color]="getSelectedLabelIconColor()" *ngIf="icon">{{icon}}</span>
      <span class="gts-btn-text">{{label}}: <b>{{ getSelectedValueIcon() }}</b></span>
      <span class="gts-btn-select-icon">expand_more</span>
    </div>
  </button>